import { atom } from "jotai";

export interface IOrderFulfillmentStatus {
    id: number;
    name: string;
}

export const orderFulfillmentStatusesAtom = atom<IOrderFulfillmentStatus[]>([]);
export const orderFulfillmentStatusesLoadingAtom = atom<boolean>(false);
